import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { PosmProductionDemandDto, PosmProductionDemandServiceProxy } from '@shared/service-proxies/service-proxies';
import { Subscription, merge } from 'rxjs';
import { PosmDemandDataSource } from '../data-source/posm-demand-datasource';
import { MatPaginator } from '@angular/material';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertType, UIMessage } from '@shared/helpers/UIMessage';

@Component({
  selector: 'kt-demand-list',
  templateUrl: './demand-list.component.html',
  styleUrls: ['./demand-list.component.scss']
})
export class DemandListComponent extends PagedListingComponentBase<PosmProductionDemandDto> implements  OnInit {
 
  portletTitle = "POSM Üretim Talepleri";

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  private subscriptions: Subscription[] = [];
  
  dataSource : PosmDemandDataSource;
  displayedColumns = ["id", "productCode", "productName", "supplierName", "amount" , "actions"];
  
  uiMessage : UIMessage;

  constructor(
    injector: Injector,
    private router : Router,
    private route : ActivatedRoute,
    private _productDemandProxy : PosmProductionDemandServiceProxy
  ) {
    super(injector);

    this.uiMessage = new UIMessage();
  }

  ngOnInit() {
    
    //Bir sayfada en cok kac kayit olacak.
    this.paginator.pageSize = 5 ; 


      //Paging evet'i set ediliyor.
    //2 durumda tetiklenir.
    //1-Sayfa degistirildiginde.
    //2-Sortlama yapildiginda.
    const paginatorSubscriptions = merge(this.paginator.page).pipe(
			tap(() => this.loadData())
		)
		.subscribe();
		this.subscriptions.push(paginatorSubscriptions);

    this.dataSource = new PosmDemandDataSource(this._productDemandProxy);

    this.loadData();
  }

  loadData(){
    this.dataSource.loadData("", false, "", 1000, 0);
  }

 
  protected list(request: PagedRequestDto, pageNumber: number, finishedCallback: Function): void {
    throw new Error('Method not implemented.');
  }
  protected delete(entity: PosmProductionDemandDto): void {
    this.uiMessage.confirm("Kayıt silinecek!", "Devam etmek istiyor musunuz?", AlertType.warning, "Evet", "İptal", () => {
        this._productDemandProxy.delete(entity.id).subscribe(res => {
          //this.uiMessage.toast.info("Kayıt silindi.");
          this.dataSource.loadData("", false, "", 1000, 0);

        });
    }, true);
  }
   create(): void {
    this.router.navigate(["../add"], {relativeTo: this.route});
  }
  protected edit(id: any): void {
    throw new Error('Method not implemented.');
  }

}
